import { RemoteCreateLead } from "../../usecases";
import { CreateLead } from "../../../domain/usecases";
import { makeApiLeadUrl, makeAxiosHttpClient } from "../http";

export const makeRemoteCreateLead = (): CreateLead =>
  new RemoteCreateLead(
    makeApiLeadUrl(),
    makeAxiosHttpClient(),
  );
